import { useQuery } from 'react-query';
import { lovageApi } from 'src/axios';

export interface LegalAgreements {
  privacy_policy: string;
  terms_of_service: string;
}

export const fetchLegalAgreements = () =>
  lovageApi.get<LegalAgreements>(`/onboarding/agreements`).then((res) => res.data);

export default function useLegalAgreements() {
  return useQuery(['legalAgreements'], fetchLegalAgreements, {});
}
